<tt-page *ngIf="!!page">
    <tt-card class="col-xs-12 col-md-4 sp-0">
        <tt-input ttLabel="salarytype_id" [(ttModel)]="page.salarytype_id" [ttReadonly]="page.is_new === '0'"></tt-input>
        <tt-input ttLabel="salarytype_name" [(ttModel)]="page.salarytype_name"></tt-input>
        <tt-input ttLabel="id_in_salaryprogram" [(ttModel)]="page.id_in_salaryprogram"></tt-input>
        <tt-select ttLabel="salarytype_paycheck" [(ttModel)]="page.salarytype_id_paycheck" [ttData]="salaryTypes"></tt-select>
        <tt-select ttLabel="unit" [(ttModel)]="page.unit_no" [ttData]="units" ttDataId="unit_no" ttDataName="unit_name"></tt-select>
        <tt-checkbox ttLabel="absence" [(ttModel)]="page.absence"></tt-checkbox>

        <ng-container *ngIf="page.absence === '1'">
            <tt-checkbox ttLabel="absence_paid" [(ttModel)]="page.absence_paid"></tt-checkbox>
            <tt-checkbox ttLabel="absence_legal" [(ttModel)]="page.absence_legal"></tt-checkbox>
        </ng-container>

        <tt-checkbox ttLabel="overtime" [(ttModel)]="page.overtime"></tt-checkbox>
        <tt-input-number *ngIf="page.overtime === '1'" ttLabel="extrapst" [(ttModel)]="page.extrapst" ttTextAlign="right" ttDecimals="2"></tt-input-number>
        <tt-checkbox ttLabel="donotsplit" [(ttModel)]="page.donotsplit"></tt-checkbox>
        <tt-checkbox ttLabel="transfer_to_paycheck" [(ttModel)]="page.transfer_to_paycheck"></tt-checkbox>
        <tt-select ttLabel="timeaccount_impact" [(ttModel)]="page.timeaccount_impact" [ttData]="impactTimeAccounts"></tt-select>
        <tt-checkbox ttLabel="is_extra" [(ttModel)]="page.is_extra"></tt-checkbox>
        <tt-select *ngIf="page.is_extra === '1'" ttLabel="extra_quantity_type" [(ttModel)]="page.extra_quantity_type_id" [ttData]="extraQuantityTypes" ttDataId="extra_quantity_type_id" ttDataName="extra_quantity_type_name"></tt-select>

        <tt-input ttLabel="prod_id" [ttModel]="page.prod_id" ttReadonly>
            <ng-container buttons>
                <tt-form-field-button *ngIf="page.prod_id > ''" ttId="goto" ttIcon="fas fa-chevron-right" ttGoto="product" [ttGotoParms]="{ prod_id: page.prod_id }"></tt-form-field-button>
            </ng-container>
        </tt-input>

        <tt-search ttLabel="prod_name" [(ttModel)]="page.prod_name" [ttSearch]="searchProducts" (ttOnSelected)="onProductSelected($event)" (ttOnClear)="onProductSelected()"></tt-search>
        <tt-button-save ttText="save" (ttClick)="saveChanges()" [ttLoading]="saving"></tt-button-save>

        <ng-container *ngIf="page.is_new === '0'">
            <tt-button ttText="delete" (ttClick)="deleteValues()" ttIcon="fas fa-trash-alt" ttType="danger" [ttLoading]="deleting"></tt-button>
            <tt-button-goto ttText="translations" ttGoto="salarytypelang" [ttGotoParms]="{ salarytype_id: page.salarytype_id }"></tt-button-goto>
        </ng-container>

        <tt-button-goto *ngIf="!!page.salarytype_id" ttText="salarytype_laboursalarytype" ttGoto="laboursalarytypes" [ttGotoParms]="{ argtype: 'salarytype_id', argvalue: page.salarytype_id }"></tt-button-goto>
    </tt-card>
</tt-page>
